export default {
  "title": "推荐人",
  "anchor": "recommender",
  "items": [
    {
      "name": "马云",
      "company": "阿里巴巴集团",
      "position": "董事局主席"
    },
    {
      "name": "李彦宏",
      "company": "百度公司",
      "position": "创始人、董事长"
    },
    {
      "name": "马化腾",
      "company": "腾讯",
      "position": "董事会主席 & 首席执行官"
    },
    {
      "name": "刘强东",
      "company": "京东",
      "position": "董事局主席 & 首席执行官"
    },
    {
      "name": "张小龙",
      "company": "微信",
      "position": "创始人、腾讯高级副总裁"
    },
    {
      "name": "王兴",
      "company": "美团",
      "position": "创始人 & CEO"
    },
    {
      "name": "雷军",
      "company": "小米科技",
      "position": "董事长 & CEO"
    },
    {
      "name": "王小川",
      "company": "搜狗公司",
      "position": "创始人 & CEO"
    },
    {
      "name": "俞永福",
      "company": "阿里巴巴文娱集团",
      "position": "董事长 & CEO"
    },
    {
      "name": "张朝阳",
      "company": "搜狐",
      "position": "董事局主席 & 首席执行官"
    },
    {
      "name": "罗永浩",
      "company": "锤子科技",
      "position": "创始人"
    },
    {
      "name": "张一鸣",
      "company": "今日头条",
      "position": "创始人 & CEO"
    },
    {
      "name": "张鹏",
      "company": "极客公园",
      "position": "创始人 & 总裁"
    },
    {
      "name": "丁磊",
      "company": "网易",
      "position": "董事局主席 & 首席执行官"
    },
    {
      "name": "陈天桥",
      "company": "盛大网络",
      "position": "董事长 & 首席执行官"
    },
    {
      "name": "程维",
      "company": "滴滴出行",
      "position": "创始人 & CEO"
    },
    {
      "name": "张涛",
      "company": "大众点评",
      "position": "创始人"
    },
    {
      "name": "陈华",
      "company": "唱吧",
      "position": "创始人 & CEO"
    },
    {
      "name": "蔡文胜",
      "company": "美图",
      "position": "董事长"
    },
    {
      "name": "周源",
      "company": "知乎",
      "position": "创始人 & CEO"
    },
    {
      "name": "冯鑫",
      "company": "暴风集团",
      "position": "董事长 & CEO"
    },
    {
      "name": "张亚勤",
      "company": "百度公司",
      "position": "总裁"
    },
    {
      "name": "姚劲波",
      "company": "58同城",
      "position": "创始人 & CEO"
    },
    {
      "name": "吴欣鸿",
      "company": "美图公司",
      "position": "创始人 & CEO"
    },
    {
      "name": "唐岩",
      "company": "陌陌",
      "position": "联合创始人、CEO、董事长"
    },
    {
      "name": "张颖",
      "company": "经纬中国",
      "position": "创始管理合伙人"
    },
    {
      "name": "沈南鹏",
      "company": "红杉资本",
      "position": "全球执行合伙人"
    },
    {
      "name": "曹毅",
      "company": "源码资本",
      "position": "创始合伙人"
    },
    {
      "name": "李开复",
      "company": "创新工场",
      "position": "创始人"
    },
    {
      "name": "宿华",
      "company": "快手",
      "position": "创始人 & CEO"
    },
  ]
}



// WEBPACK FOOTER //
// ./src/mock/recommender.js